<template>
  <div class="tags">
    <QueryTag
      :key="idx"
      v-for="(tag, idx) of tags"
      :tagName="tag"
      size="small"
      type="info"
    ></QueryTag>
  </div>
</template>

<script>
import QueryTag from "@/components/QueryTag";
export default {
  name: "TableTags",
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  components: {
    QueryTag
  }
};
</script>

<style scoped lang="scss">
.el-tag {
  margin-left: 2px;
  margin-right: 2px;
}
</style>
